export class PostBulkRejectionPayload {
  containerId: number;
  compSearchId: number;
  jurisdictionId: number;
  pliTypeId: number;
  pliAverageTypeId: number;
  rejectionTypeId: number;
}
